/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 * vc-transport-message.schema.js --
 *
 * schema used for vc session protocol in little endian
 * https://github.com/euc-vdi/cart/blob/main/bora/apps/rde/rdpvcbridge/common/vcTransportMsg.h
 * @format
 */
export const vcTransportMsgSchema = {
   macros: {
      VCWIREMSG_PAYLOAD_FIXED_SIZE: 128 - 12, // precalculate to reduce marker configuration effort
      MAX_COMPUTERNAME_LENGTH: 64,
      CHANNEL_NAME_LEN: 8
   },
   structs: {
      VCWireMsgHdr: new Map([
         ["MsgType", "INT32"],
         ["MsgID", "UINT32"],
         ["VcStreamID", "INT32"]
      ]),
      VCWireMsgSessionInfoQuery: new Map([
         ["InfoClass", "UINT32"],
         ["NBytes", "UINT32"],
         ["PaddingAlign", "ALIGN_TO[..VCWIREMSG_PAYLOAD_FIXED_SIZE]"],
         ["PData", "BYTE[.NBytes]"]
      ]),
      VCWireMsgSessionInfoResponse: new Map([
         ["QueryMsgID", "UINT32"],
         ["PData_OLD", "UINT32"],
         ["NBytes", "UINT32"],
         ["PaddingAlign", "ALIGN_TO[..VCWIREMSG_PAYLOAD_FIXED_SIZE]"],
         ["PData", "BYTE[.NBytes]"]
      ]),
      VCWireMsgData: new Map([
         ["PData_OLD", "UINT32"],
         ["NBytes", "UINT32"], //use UINT since length can't be negative.
         ["ChannelName", "CHAR[..CHANNEL_NAME_LEN]"],
         ["PaddingAlign", "ALIGN_TO[..VCWIREMSG_PAYLOAD_FIXED_SIZE]"],
         ["PData", "BYTE[.NBytes]"]
      ]),
      // fallback struct, error log should be print when used
      VCWireMsgNone: new Map([["PaddingAlign", "ALIGN_TO[..VCWIREMSG_PAYLOAD_FIXED_SIZE]"]]),
      VCWireMsg: new Map<string, any>([
         ["Header", "VCWireMsgHdr"],
         [
            "Payload",
            [
               {
                  type: "SessionInfoQuery",
                  format: new Map([["sessionInfoQuery", "VCWireMsgSessionInfoQuery"]])
               },
               {
                  type: "SessionInfoResponse",
                  format: new Map([["sessionInfoResponse", "VCWireMsgSessionInfoResponse"]])
               },
               {
                  type: "Data",
                  format: new Map([["data", "VCWireMsgData"]])
               },
               {
                  type: "None",
                  format: new Map([["none", "VCWireMsgNone"]])
               }
            ]
         ]
      ]),
      PduHdr: new Map([
         ["Type", "UINT32"],
         ["Context", "UINT64"],
         ["DataLen", "UINT32"]
      ]),
      ScannerMsg: new Map([
         ["Type", "UINT32"],
         ["Context", "UINT64"],
         ["DataLen", "UINT32"],
         ["Payload", "UINT8[.DataLen]"]
      ])
   }
};
